import React from 'react'

import Apply from '../components/Apply'
import BannerLink from '../components/BannerLink'
import CustomHelmet from '../components/CustomHelmet'
import Row from '../components/Shared/Row'
import Column from '../components/Shared/Column'
import AdmissionCountry from '../components/AdmissionCountry'
import gsap from 'gsap'
import Hero from '../components/Destination/Hero'
import VideoHero from '../components/Destination/Hero/VideoHero'
import BannerImage from '../components/Destination/BannerImage'
import marked from 'marked'
import AdmissionsSignup from '../components/Shared/AdmissionsSignup'
import Signup from '../components/_Redesign/Signup'


import CardSlider from '../components/Shared/AdmissionsCards'

class admissions extends React.Component {
	componentDidMount() {
		const location = this.props.location.pathname
		const scriptLocation = 'https://assets.calendly.com/assets/external/widget.js'

		if (typeof window !== 'undefined' ) {
			if( location == '/academy/parents/' || location == '/academy/parents') {
				const scriptElement = document.createElement('script')
				scriptElement.src = scriptLocation
				this.refs.scriptLocation.appendChild(scriptElement)
			}
		}
	}
	render() {
		const academyPages = [
			'/academy',
			'/academy/',
			'/academy/interest',
			'/academy/interest/',
			'/academy/experience',
			'/academy/experience/'
		]
		const {
			data: { page }
		} = this.props
		const node = page.edges[0].node
		const pageSlug = this.props.location.pathname

		// console.log('THE PAGE SLUG ==== ', pageSlug, academyPages, node.admissionsTemplate);
		// console.log('page slug == ', pageSlug)
		return (
			<div className={`page-admissions${academyPages.includes(pageSlug) || node.admissionsTemplate ? ' gcy-institute' : '' }`}>
				<CustomHelmet data={node.seoData} />
				{node.map && (
					<AdmissionCountry
						map={node.map}
						title1={node.itemTitle1}
						length={node.length}
						title2={node.itemTitle2}
						destinations={node.destinations}
						title3={node.itemTitle3}
						tuition={node.tuition}
						title4={node.itemTitle4}
						description4={node.description4}
						link={node.buttonLink}
						academy={ node.admissionsTemplate ? node.admissionsTemplate : academyPages.includes(pageSlug) }
					/>
				)}
				{ pageSlug == '/academy' || pageSlug == '/academy/' &&
					<div className="hero-wrap">
						<VideoHero
							title={node.pageTitle}
							description={node.mainDescription.mainDescription}
							location={ pageSlug }
							admissionsTemplate={ node.admissionsTemplate } />
					</div>
				}
				{ pageSlug != '/academy' && pageSlug != '/academy/' &&
					<div className="hero-wrap">
						<Hero
							title={node.pageTitle}
							featuredImage={node.heroImage}
							caption={node.heroCaption}
							description={node.mainDescription.mainDescription}
							location={ pageSlug }
							admissionsTemplate={ node.admissionsTemplate ? node.admissionsTemplate : false }
						/>
					</div>
				}


				{node.flexSections.length > 0 &&
					node.flexSections.map((section, index) => (
						<span key={index}>
							<div className="section">
								<Row className={`no-padding section-content${section.cardView === true ? ' card-section no-padding-top no-padding-bottom pull-up-40' : '' }`}>
									<div className="inner">
										{section.sectionTitle && section.cardView !== true && (
											<h2
												className="h2"
												dangerouslySetInnerHTML={{
													__html: section.sectionTitle
												}}
											/>
										)}
										{ section.sectionItems.length && section.cardView === true &&
											<div>
										        <CardSlider
										          cards={section.sectionItems}
										        />
											</div>
										}
										{section.sectionItems.length && section.cardView !== true &&
											section.sectionItems.map((item, index) => (
												<span id={ item.hashId ? item.hashId : ''} key={index} className="section-group">
													{item.title && (
														<h3
															className="h3"
															dangerouslySetInnerHTML={{ __html: item.title }}
														/>
													)}
													{item.text && (
														<span
															dangerouslySetInnerHTML={{
																__html: marked(item.text.text)
															}}
														/>
													)}
													{item.question && (
														<h3
															className="h3"
															dangerouslySetInnerHTML={{
																__html: item.question
															}}
														/>
													)}
													{item.answer && (
														<span
															dangerouslySetInnerHTML={{
																__html: marked(item.answer.answer)
															}}
														/>
													)}

												</span>
											))}
									</div>
								</Row>
								{
									/* (pageSlug === '/academy/' || pageSlug === '/academy') &&
									<div className="apply-wrap reduced-margin">
										<Apply
											title="Educators - Refer your students!"
											content="If you're a teacher share this unique opportunity with your students by referring them to apply for Global Citizen Academy!"
				  						    buttonTitle="Refer a student"
				  						    buttonUrl="/refer/"
										/>
									</div> */
								}
								{section.bannerImage && (
									<span>
									{
										this.props.location.pathname === "/tech-for-good-scholarship/" &&
										<div className="apply-wrap">
											<BannerLink
												title="Educators - Nominate your Students!"
												content="<p style='text-align:center;'>If you're a teacher, share this unique opportunity with your students<br/>by nominating them to apply for Global Citizen Year!</p>"
												linkText="Nominate a Student"
												link="/nominate-a-student/"
												alignCenter
												reducedPadding
												/>
										</div>
									}
									<div className="banner-wrap" style={this.props.location.pathname === "/tech-for-good-scholarship/" ? {marginTop: 0} : {} }>
										<BannerImage image={section.bannerImage} />
									</div>
									</span>
								)}
							</div>
						</span>
					))}

				{
					node.faqItem &&
					<Row className="no-padding section-content">
						<div className="inner">
							{node.faqSectionTitle && (
								<h2
									className="h2"
									dangerouslySetInnerHTML={{ __html: node.faqSectionTitle }}
								/>
							)}
							{node.faqItem && node.faqItem.length &&
								node.faqItem.map((item, index) => (
									<div className="section-group flex-faq" key={index}>
										{item.question && (
											<h3
												className="h3"
												dangerouslySetInnerHTML={{
													__html: item.question
												}}
											/>
										)}
										{item.answer && (
											<p
												dangerouslySetInnerHTML={{
													__html: marked(item.answer.answer)
												}}
											/>
										)}
									</div>
								))}
							{node.link && node.link.link && node.link.text && (
								<a className="hoverlink" href={`${node.link.link}`}>
									{node.link.text}
								</a>
							)}
						</div>
					</Row>
				}
				{
					!academyPages.includes(pageSlug) && !node.showAdmissionsRfi &&
					<div className="apply-wrap">
						<Apply
							title="It's time to break out from the expected"
							buttonUrl={'/apply/'}
						/>
					</div>
				}
				{
					/* (pageSlug == '/academy/tuition' || pageSlug == '/academy/tuition/') &&
						<div className="apply-wrap">
							<Apply
								title={ node.admissionsRfiText ? node.admissionsRfiText : "Let's get started!" }
								buttonUrl={ node.admissionsRfiPageLink ? node.admissionsRfiPageLink : '/academy/apply/' }
							/>
						</div> */
				}
				{
					(pageSlug == '/academy/interest' || pageSlug == '/academy/interest/' || node.showAdmissionsRfi ) &&
						<div style={{ zIndex: '50', position: 'relative' }} id="signup">
							<Signup
						      title={ node.admissionsRfiText ? node.admissionsRfiText : "Sign up for more!" }
							  location={ this.props.location }
							  color={ 'Black' }
						    />
						</div>
				}
				{
					/* (pageSlug == '/academy/experience' ||
					 pageSlug == '/academy/experience/') &&
					<div className="apply-wrap">
						<Apply
							title="It's time to break out from the expected"
							buttonUrl={'/academy/apply/'}
						/>
					</div> */
				}
				<div ref="scriptLocation" />
			</div>
		)
	}
}

export default admissions

export const admissionsQuery = graphql`
	query admissionsQuery($id: String!) {
		page: allContentfulAdmissionsPage(filter: { id: { eq: $id } }) {
			edges {
				node {
					admissionsTemplate
					pageTitle
					heroImage {
						sizes(quality: 100, maxWidth: 1800) {
							...GatsbyContentfulSizes_withWebp
						}
						file {
							url
						}
					}
					heroCaption
					link {
						link
						text
					}
					mainDescription {
						mainDescription
					}
					itemTitle1
					itemTitle2
					itemTitle3
					itemTitle4
					length
					destinations
					tuition
					description4
					map {
						description
						file {
							url
						}
					}
					buttonLink {
						text
						link
					}

					flexSections {
						sectionTitle
						cardView
						sectionItems {
							... on ContentfulFaqItem {
								__typename
								question
								answer {
									answer
								}
							}
							... on ContentfulTitleText {
								__typename
								title
								text {
									text
								}
								hashId
							}
							... on ContentfulCountryCard {
								__typename
								title
								description
								link
						        backgroundImage {
						            sizes(quality:100, maxWidth:800) {
						                ...GatsbyContentfulSizes_withWebp
						            }
						          file {
						            url
						            fileName
						            contentType
						          }
						          title
						        }
							}
						}
						bannerImage {
							sizes(quality: 100, maxWidth: 1800) {
								...GatsbyContentfulSizes_withWebp
							}
							title
							file {
								url
							}
						}
					}
					faqSectionTitle
					faqItem {
						question
						answer {
							answer
						}
					}
					showAdmissionsRfi
					admissionsRfiText
					seoData {
						pageTitle
						pageDescription {
							pageDescription
						}
						keywords
						openGraphTitle
						openGraphDescription {
							openGraphDescription
						}
						openGraphImage {
							file {
								url
							}
						}
			            additionalScripts {
			              id
			              internal {
			                content
			              }
			            }
					}
				}
			}
		}
	}
`

//
// map {
//   file {
//     url
//     contentType
//     fileName
//   }
//   title
// }



// WEBPACK FOOTER //
// ./src/templates/admissions.js